import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ThemeComponent } from './theme.component';

const routes: Routes = [
  {
    path: '',
    component: ThemeComponent,
    children: [
      {
        path: '',
        loadChildren: 'app/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'dashboard',
        loadChildren: 'app/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'roles',
        loadChildren: 'app/roles/roles.module#RolesModule'
      },
      {
        path: 'clients',
        loadChildren: 'app/clients/clients.module#ClientsModule'
      },
      {
        path: 'guest',
        loadChildren: 'app/clients/clients.module#ClientsModule'
      },
      {
        path: 'staff',
        loadChildren: 'app/staff/staff.module#StaffModule'
      },
      {
        path: 'modules',
        loadChildren: 'app/modules/modules.module#ModulesModule'
      },
      {
        path: 'departments',
        loadChildren: 'app/departments/departments.module#DepartmentsModule'
      },
      {
        path: 'questions',
        loadChildren: 'app/questions/questions.module#QuestionsModule'
      },
      {
        path: 'products',
        loadChildren: 'app/products/products.module#ProductsModule'
      },
      {
        path: 'orders',
        loadChildren: 'app/orders/orders.module#OrdersModule'
      },
      {
        path: 'alerts',
        loadChildren: 'app/alerts/alerts.module#AlertsModule'
      },
      {
        path: 'email-templates',
        loadChildren: 'app/email-templates/email-templates.module#EmailTemplatesModule'
      },
      {
        path: 'trump-bucks',
        loadChildren: 'app/loyalty-programs/loyalty-programs.module#LoyaltyProgramsModule'
      },
      {
        path: 'categories',
        loadChildren: 'app/categories/categories.module#CategoriesModule'
      },
      {
        path: 'promo-codes',
        loadChildren: 'app/promo-codes/promo-codes.module#PromoCodesModule'
      },
      {
        path: 'all-guest-requests',
        loadChildren: 'app/all-guest-requests/all-guest-requests.module#AllGuestRequestsModule'
      },
      {
        path: 'admin-settings',
        loadChildren: 'app/admin-settings/admin-settings.module#AdminSettingsModule'
      },
      {
        path: 'redeemed-logs',
        loadChildren: 'app/redemption-logs/redemption-logs.module#RedemptionLogsModule'
      },
      {
        path: 'stay-contacts',
        loadChildren: 'app/stay-contacts/stay-contacts.module#StayContactsModule'
      },
      {
        path: 'local-attractions/requests',
        loadChildren: 'app/local-attractions-requests/local-attractions-requests.module#LocalRequestsModule'
      },
      {
        path: 'logs',
        loadChildren: 'app/logs/logs.module#LogsModule'
      },
      {
        path: 'manage-notifications',
        loadChildren: 'app/manage-notifications/manage-notifications.module#ManageNotificationsModule'
      },
      {
        path: 'hotel-marketing',
        loadChildren: 'app/hotel-marketing/hotel-marketing.module#HotelMarketingModule'
      },
      {
        path: 'rooms',
        loadChildren: 'app/rooms/rooms.module#RoomsModule'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ThemeRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/theme/theme.routing.ts